export const getAssessmentFormData = (formData, values) => {
  const {
    label,
    assessment,
    assessment_upload = [],
    reviewer_ids,
    // ! assessment commenting for V1
    // subject,
    // body,
    // attachments = [],
    // from = [],
    // cc = [],
    // bcc = [],
    // atsCommTemplateId,
    scoreCards = [],
    reviewer_attachments = [],
    reviewer_instructions = '',
    content_updated = false,
    feedback_description = '',
    is_feedback_mandatory = false,
    rating_description = '',
    schedule_at = {},
    ext_test_name = '',
    ext_test_id = '',
    ext_assessment_link = '',
    scorecard_required,
  } = values;

  // Details
  formData.append('name', label);
  formData.append('text', assessment);
  if (ext_test_name) formData.append('ext_test_name', ext_test_name);
  if (ext_test_id) formData.append('ext_test_id', ext_test_id?.value);
  if (ext_assessment_link)
    formData.append('ext_assessment_link', ext_assessment_link);
  assessment_upload?.forEach((file) => {
    if (file instanceof File) formData.append('attachments[]', file);
    if (file?.id) formData.append('attachments[]', file?.id);
  });
  if (assessment_upload?.length === 0) {
    formData.append('attachments[]', []);
  }
  reviewer_attachments?.forEach((file) => {
    if (file instanceof File)
      formData.append('reviewer_instructions_attachments[]', file);
    if (file?.id)
      formData.append('reviewer_instructions_attachments[]', file?.id);
  });
  reviewer_ids?.forEach((id) => {
    formData.append('participant_ids[]', id);
  });
  if (reviewer_instructions)
    formData.append('reviewer_instructions', reviewer_instructions);
  if (
    feedback_description &&
    feedback_description !== '' &&
    feedback_description !== null
  )
    formData.append('scorecard_feedback_description', feedback_description);
  formData.append('is_feedback_mandatory', is_feedback_mandatory);
  if (scorecard_required !== undefined)
    formData.append('scorecard_required', scorecard_required);
  if (
    rating_description &&
    rating_description !== '' &&
    rating_description !== null
  )
    formData.append('scorecard_rating_description', rating_description);
  // scorecard
  scoreCards?.forEach((scorecard, index) => {
    formData.append(`questions[${index}][question]`, scorecard?.question);
    formData.append(`questions[${index}][type]`, scorecard?.type);
    formData.append(
      `questions[${index}][mandatory]`,
      scorecard?.mandatory || false
    );
    formData.append(
      `questions[${index}][description]`,
      scorecard?.description || ''
    );
    scorecard?.options?.forEach((option) => {
      formData.append(
        `questions[${index}][options][]`,
        option?.optionText || option
      );
    });
  });
  if (scoreCards?.length === 0) {
    formData.append(`questions[]`, []);
  }

  if (content_updated) formData.append('content_updated', true);

  if (schedule_at?.formattedTime) {
    formData.append('scheduled_at', schedule_at.formattedTime);
  }
  if (schedule_at?.timezoneValue?.key) {
    formData.append('scheduled_at_timezone', schedule_at.timezoneValue.key);
  }

  // // Email
  // if (atsCommTemplateId)
  //   formData.append('email[ats_comm_template_id]', atsCommTemplateId);
  // formData.append('email[sender_id]', from);
  // formData.append('email[subject]', subject);
  // formData.append('email[body]', body);
  // cc?.forEach((id) => {
  //   formData.append('email[cc_user_ids][]', id);
  // });
  // bcc?.forEach((id) => {
  //   formData.append('email[bcc_user_ids][]', id);
  // });
  // attachments?.forEach((file) => {
  //   if (file instanceof File) formData.append('email[attachments][]', file);
  //   if (file?.id) formData.append('email[attachments][]', file?.id);
  // });
  return formData;
};
